// extracted by mini-css-extract-plugin
export default {"box":"Rag_8yasKA3TrXVVRZb0"};